export const LOGIN_STATUS = {
    LOGGED_OUT: 'LOGGED_OUT',
    LOGGING_IN: 'LOGGING_IN',
    WAITING_FOR_FIRST_2FA: 'WAITING_FOR_FIRST_2FA',
    WAITING_FOR_2FA: 'WAITING_FOR_2FA',
    WAITING_FOR_2FA_RETRY: 'WAITING_FOR_2FA_RETRY',
    LOGIN_ERROR: 'LOGIN_ERROR',
    LOGGED_IN: 'LOGGED_IN',
};
